export default __webpack_public_path__ + "static/media/microsoft-workspace-bulk.b16b99cf.png";